import React from "react";
import { cn } from "@/lib/utils";

export interface TabItem {
  key: string;
  label: string;
  count?: number;
}

/** Underlined tabs with counts, for narrowing a list by status */
export function StatusTabs({ tabs, active, onChange, label = "Filter by status" }: { tabs: TabItem[]; active: string; onChange: (key: string) => void; label?: string }) {
  return (
    <div role="tablist" aria-label={label} className="flex gap-0.5 overflow-x-auto border-b border-border">
      {tabs.map((t) => {
        const on = t.key === active;
        return (
          <button
            key={t.key}
            type="button"
            role="tab"
            aria-selected={on}
            onClick={() => onChange(t.key)}
            className={cn(
              "h-[34px] whitespace-nowrap border-b-2 px-3 text-[13px] outline-none transition-colors focus-visible:bg-muted",
              on ? "border-primary font-semibold text-foreground" : "border-transparent text-muted-foreground hover:text-foreground",
            )}
          >
            {t.label}
            {t.count !== undefined && (
              <span className={cn("ml-1.5 font-mono text-[11px]", on ? "rounded-full bg-accent px-1.5 py-px text-primary" : "text-muted-foreground")}>{t.count}</span>
            )}
          </button>
        );
      })}
    </div>
  );
}
